import { render, staticRenderFns } from "./BButtonLoading.vue?vue&type=template&id=df4533ca&"
import script from "./BButtonLoading.vue?vue&type=script&lang=js&"
export * from "./BButtonLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports